import * as React from 'react';
import * as Article from '@elevio-kb/fe/lib/toolkit/article';
import { IArticle } from '@elevio-kb/fe/lib/types/index';
import useArticle from '@elevio-kb/fe/lib/hooks/useArticle';
import useTranslation from '@elevio-kb/fe/lib/hooks/useTranslation';
import { Helmet } from '@elevio-kb/fe/lib/toolkit/meta';
import { stripTags } from '@elevio-kb/fe/lib/utils';
import { Header } from '../components/Header';
import Alert from '../components/Alert';
import { ArticleFeedback } from '../components/ArticleFeedback';
import { SideBar } from '../components/SideBar';
import { Footer } from '../components/Footer';
import AccessBanner from '../components/AccessBanner';

export function articleMetaDescription(article: IArticle): string {
  let metaDescription = stripTags(article.body.substr(0, 200)) + '...';
  if (article.summary) {
    metaDescription = article.summary;
  }
  return metaDescription;
}

const Page = () => {
  const article = useArticle();
  const { t } = useTranslation();
  if (!article) return null; // this can't happen

  // const kbMeta = articleMetaDescription(article);
  const kbTitle = t('kb_title');
  const title = `${article.title} - ${kbTitle}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header />

      {/* Override the meta description to be article summary */}
      {/* <Helmet>
        <>
          <meta name="description" content={kbMeta}></meta>
          <meta property="og:description" content={kbMeta} />
        </>
      </Helmet> */}

      <div className="bg-color">
        <Alert />
        <div id="js-article-container" className="container article-show">
          <div className="row">
            <div className="col col-sm-12 col-md-8 col-push-md-4">
              <div
                id="js-article-content"
                className="page-text-color article-content"
              >
                <AccessBanner />
                <h1 className="articleTitle" data-testid="article-title">
                  <Article.Title />
                </h1>

                <Article.Body className="articleBody" noStyles />
                <ArticleFeedback className="feedbackRoot" />
              </div>
            </div>

            <div className="col col-sm-12 col-md-4 col-pull-md-8">
              <SideBar />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Page;
